<style lang="scss">
@import 'assets/style.scss';
@import 'assets/app.scss';
</style>

<template>
  <div>
    <navbar-x />

    <div class="module">
      <navbar-y />
      <titlebar />

      <transition name="fade">
        <router-view :key="$route.path" />
      </transition>

      <message v-show="messages" />
    </div>
  </div>
</template>

<script>
import cookies from 'js-cookie'
import {mapState} from 'vuex'
import store from '@/store/store'
import router from '@/config/router'

import titlebar from '@/components/layout/titlebar'
import navbarX from '@/components/layout/navbar-x'
import navbarY from '@/components/layout/navbar-y'
import message from '@/components/layout/message'

export default {
  components: {
    titlebar,
    navbarX,
    navbarY,
    message,
  },
  computed: {
    ...mapState(['messages', 'webkey']),
  },
  async beforeCreate() {
    const {webkey} = store.state

    if (!webkey || !webkey.servers || webkey.servers.length == 0) {
      router.push({name: '403', params: {onload: true}})
    }
    await store.dispatch('init')

    const url = cookies.get('TAC_PBT_LOGIN_URL')
    if (url) {
      cookies.remove('TAC_PBT_LOGIN_URL', {
        domain: '.industrysoftware.automation.siemens.com',
        path: '/',
      })
      router.push({path: url.substring(2)})
    }
  },
}
</script>
